module.exports = __webpack_public_path__ + "img/Search.1f93bced.svg";